<template>
  <div class="container-fluid my-3 record" style="min-height:50vh">
    <popUp v-if="toggle" v-on:doClose="close" :size="'large'">
      <div class="pop-title" slot="title">
      </div>
      <div slot="title">
        <h1 class="mx-3 mb-2" style="font-weight:600">{{ copy.radarChart }}</h1>
      </div>
      <div slot="left-box" class="info-main mt-3 d-flex  align-items-center  justify-content-center rwd-hide" v-if="datasets" >
        <RadarChart class=" m-auto" :datasets="datasets" />
      </div>
      <div slot="right-box" class=" mt-3 d-flex  align-items-center  justify-content-center " v-if="datasets" >
        <div class="info-main">
          <h4 class="mb-3" style="font-weight:600">{{ copy.averageScore }}: {{ radarInfo.Score }}</h4>
          <span>{{ copy.speakingResult }}</span>
          <ul
            class="score-info list-group list-group-horizontal"
            v-for="([key, item], index) in orderedScores"
            :key="key"
          >
            <li style="min-width: 120px;max-width: 120px;" class="score-title list-group-item">{{ tableTranslate(key) }}</li>
            <li style="min-width: 120px;max-width: 120px;" class="score score-content list-group-item">{{ item }}</li>
          </ul>
        </div>
      </div>
      <div class="radarInfo my-3 rwd-hide" v-if="radarInfo" slot="feedback">
        <hr>
        <button type="button" @click="playAudio('original', currentNo)" class="btn btn-outline-secondary mx-2">{{ copy.courseAudio }}</button>
        <button type="button" @click="playAudio('audio', currentNo)" class="btn btn-outline-secondary">{{ copy.myRecording }}</button>
        <br/>
        <span class="badge badge-success">{{ copy.good }}</span>
        <span class="badge badge-warning mx-2">{{ copy.fair }}</span>
        <span class="badge badge-danger">{{ copy.keepTrying }}</span>
        <div class="pointer mt-2">
          <span style="font-weight:600;weight:200px">{{ copy.courseSentence }}:</span>
          {{radarInfo.Text}}
        </div>
        <div>
          <span style="font-weight:600">{{ copy.myVoice }}: </span>
          <span v-html="applyColorToWords(radarInfo.Text, radarInfo.Words)"></span>
      </div>
      </div>
    </popUp>
    <div>
      <div class="col-12" style="min-height:40vh">
        <div>
          <table class="rwd-table mt-3">
          <thead>
            <tr>
              <th colspan="6" class="main-title">{{ copy.examName }}</th>
            </tr>
          </thead>
            <tbody>
              <tr>
                <th>{{ copy.examName }}</th>
                <th>{{ copy.startTime }}</th>
                <th>{{ copy.endTime }}</th>
                <th>{{ copy.teacherName }}</th>
              </tr>
              <tr v-if="examData">
                <td :data-th="copy.examName">
                  {{examData.name}}
                </td>
                <td :data-th="copy.startTime">
                  {{examData.begin_at}}
                </td>
                <td :data-th="copy.endTime">
                  {{examData.end_at}}
                </td>
                <td :data-th="copy.teacherName">
                  {{examData.creator}}
                </td>
              </tr>
            </tbody>
          </table>
          <div class="my-2">
            <span class="mr-2">{{ copy.question }}:</span>
            <select v-model="selected" v-if="examData">
              <option v-for="(item, index) in examData.lessons" :key="index" :value="index">
                <span @click="getSentences(index)">
                  {{ item.localName }}
                </span>
              </option>
            </select>
          </div>
          <table class="rwd-table mt-3">
              <tbody>
                <tr>
                  <th>{{ copy.sentence }}</th>
                  <th>{{ copy.audio }}</th>
                  <th>{{ copy.score }}</th>
                  <th>{{ copy.radarChart }}</th>
                </tr>
                <tr v-for="(item, index) in sentences" :key="index">
                  <td class="pointer" :data-th="copy.sentence" @click="playAudio('original',item.no)">
                    {{item.text}}
                    <audio :id="`originalAudio${item.no}`">
                      <source :src="item.audio" type="audio/wav" />
                    </audio>
                  </td>
                  <td :data-th="copy.audio">
                    <audio v-if="item.data" :id="`audio${item.no}`" controls>
                      <source :src="item.data.AudioUrl" type="audio/wav" />
                    </audio>
                  </td>
                  <td :data-th="copy.score">
                    {{item.score !== null ? item.score : 0}}
                  </td>
                  <td :data-th="copy.radarChart">
                    <button style="white-space:nowrap;" v-if="item.data" type="button" @click="openRadarInfo(item.data, item.no)" class="btn btn-primary mx-3">{{ copy.view }}</button>
                    <button style="white-space:nowrap;" v-else type="button" disabled class="btn btn-primary mx-3">{{ copy.view }}</button>
                  </td>
                </tr>
              </tbody>
            </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import PopUp from '@/components/PopUp.vue'
import moment from 'moment';
import RadarChart from '@/components/RadarChart.vue'
import 'vue2-datepicker/index.css';
import api from '../store/api'

export default {
  name: 'Exam-detail',
  data () {
    return {
      pageCount: 10,
      pageIndex: 1,
      examData: null,
      currentNo: 0,
      selected: 0,
      sentences: [],
      datasets: null,
      toggle: false,
      radarInfo: null,
      feedback: null
    }
  },
  components: {
    PopUp,
    RadarChart
  },
  computed: {
    currentLocale () {
      return this.$i18n ? this.$i18n.locale : 'tw'
    },
    copy () {
      const copy = {
        tw: {
          radarChart: '能力雷達圖',
          averageScore: '平均分數',
          speakingResult: '口說練習評估結果如下:',
          courseAudio: '課程音檔',
          myRecording: '我的錄音',
          good: '良好',
          fair: '尚可',
          keepTrying: '再加油',
          courseSentence: '課程句子',
          myVoice: '我的聲音',
          examName: '考場名稱',
          startTime: '開始時間',
          endTime: '結束時間',
          teacherName: '老師姓名',
          question: '題目',
          sentence: '句子',
          audio: '音檔',
          score: '成績',
          view: '查看',
          unsupportedMentorAi: '目前版本不支持MentorAi',
          accuracy: '精確度',
          completeness: '完整性',
          fluency: '流暢度',
          prosody: '韻　律',
          unknown: '未知'
        },
        en: {
          radarChart: 'Skill Radar Chart',
          averageScore: 'Average Score',
          speakingResult: 'Speaking practice evaluation results:',
          courseAudio: 'Course Audio',
          myRecording: 'My Recording',
          good: 'Good',
          fair: 'Fair',
          keepTrying: 'Keep Trying',
          courseSentence: 'Course Sentence',
          myVoice: 'My Voice',
          examName: 'Exam Name',
          startTime: 'Start Time',
          endTime: 'End Time',
          teacherName: 'Teacher Name',
          question: 'Question',
          sentence: 'Sentence',
          audio: 'Audio',
          score: 'Score',
          view: 'View',
          unsupportedMentorAi: 'This version does not support MentorAi.',
          accuracy: 'Accuracy',
          completeness: 'Completeness',
          fluency: 'Fluency',
          prosody: 'Prosody',
          unknown: 'Unknown'
        }
      }
      return copy[this.currentLocale] || copy.tw
    },
    now () {
      return moment().format("YYYY-MM-DD HH:mm");
    },
    groupId () {
      return this.$store.state.personalData.group_id
    },
    examId () {
      return this.$route.params.examId
    },
    orderedScores() {
      const order = [
        'AccuracyScore',
        'FluencyScore',
        'CompletenessScore',
        'ProsodyScore'
      ]
      return order.map(key => [key, this.radarInfo.Scores[key]])
    }
  },
  watch: {
    selected (val) {
      this.sentences = this.examData.lessons[val].sentences
      this.audiosLoad()
    }
  },
  mounted () {
    this.getRoomList()
  },
  methods: {
    async getRoomList () {
      const { data } = await api.get(`liveabc/rooms/${this.examId}/answers`)
      this.examData = data.data
      this.sentences = data.data.lessons[this.selected].sentences
    },
    openRadarInfo (el, no) {
      this.pauseAll()
      this.radarInfo = el
      // this.mergedFeedback(el)
      this.currentNo = no
      if (el.Scores) {
        this.openRadarChart(el.Scores)
      } else {
        alert(this.copy.unsupportedMentorAi)
      }
    },
    openRadarChart (el) {
      const data = {
        'PronScore' : 0,
        'AccuracyScore': 0,
        'CompletenessScore': 0,
        'FluencyScore': 0,
        'ProsodyScore': 0
      }
      const order = [
        'PronScore',
        'AccuracyScore',
        'CompletenessScore',
        'FluencyScore',
        'ProsodyScore'
      ]
      const arr = order.map(key => el[key] ?? data[key])
      this.datasets = {
        labels: [ this.copy.averageScore, this.copy.accuracy, this.copy.fluency, this.copy.completeness, this.copy.prosody],
        datasets: [
          {
            label: '',
            backgroundColor: '#f87979a5',
            radius: 6,
            pointRadius: 6,
            pointBorderWidth: 3,
            data: arr,
            borderColor: '#f87979',
          }
        ]
      }
      this.toggle = true
    },
    close (close) {
      this.toggle = close
      this.radarInfo = null
      this.currentNo = 0
      this.pauseAll()
    },
    audiosLoad () {
      const audios = document.getElementsByTagName('audio')
      for (let i = 0; i < audios.length; i++) {
        audios[i].load()
      }
    },
    tableTranslate (el) {
      switch (el) {
        case 'AccuracyScore':
          return this.copy.accuracy
        case 'CompletenessScore':
          return this.copy.completeness
        case 'FluencyScore':
          return this.copy.fluency
        case 'ProsodyScore':
          return this.copy.prosody
        default:
          return this.copy.unknown
      }
    },
    mergedFeedback (el) {
      const part_feedback = el.part_feedback
      const part_scoresArray = el.part_scores
      const part_scores = {}
      part_scoresArray.forEach((score, index) => {
        const partName = this.getPartNameFromIndex(index)
        part_scores[partName] = score
      })
      const mergedFeedback = {}
      for (const part in part_feedback) {
        if (part_scores.hasOwnProperty(part)) {
          mergedFeedback[part] = {
            feedback: part_feedback[part],
            score: part_scores[part]
          }
        }
      }
      this.feedback = mergedFeedback
    },
    playAudio (type, id) {
      // this.current = id
      if (type == 'original') {
        let audio = document.getElementById(`originalAudio${id}`)
        this.pauseAll()
        audio.load()
        audio.play()
      } else {
        let audio = document.getElementById(`audio${id}`)
        this.pauseAll()
        audio.load()
        audio.play()
      }
    },
    pauseAll () {
      const audios = document.getElementsByTagName('audio')
      const self = this
      const allAudios = []
      allAudios.forEach.call(audios, function (i) {
        i.currentTime = 0
        i !== self && i.pause()
      })
    },
    mapErrorTypeToStatus (errorType) {
      switch (errorType) {
        case "None":
          return 0; // green
        case "Mispronunciation":
        case "Monotone":
          return 1; // orange
        case "Omission":
          return 2; // red
        default:
          return null; // 不顯示
      }
    },
    applyColorToWords(text, wordStatus) {
      const statusToColor = {
        "0": "green",
        "1": "orange",
        "2": "red"
      }
      // 建立一個可變的 wordStatus 副本，以便我們可以使用和移除項目
      const availableWordStatus = [...wordStatus]
      // 拆開字與標點
      const wordsWithPunctuation = text.match(/[\w'$-]+|[.,!?;:]/g)
      if (!wordsWithPunctuation) {
        return text // 如果沒有匹配到任何單字或標點，直接返回原文本
      }
      const colorizedWords = wordsWithPunctuation.map(word => {
        if (/[\w'$-]+/.test(word)) {
          // 尋找第一個匹配的、尚未使用的狀態的索引
          const statusIndex = availableWordStatus.findIndex(
            item => item.Word.trim().toLowerCase() === word.trim().toLowerCase() && item.ErrorType !== "Insertion"
          )
          if (statusIndex !== -1) {
            // 取得狀態物件，並將其從可用列表中移除
            const [statusObj] = availableWordStatus.splice(statusIndex, 1)
            const status = this.mapErrorTypeToStatus(statusObj.ErrorType)
            if (status !== null && status !== -1) {
              const color = statusToColor[status.toString()]
              return `<span style="color: ${color};">${word}</span>`
            }
          }
          return word
        } else {
          return word // 標點符號保留
        }
      })
      return colorizedWords.join(' ')
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/color.scss";
.record {
  text-align: left;
  .layout {
    min-height: 50vh;
  }
}
  table {
    border-collapse: collapse;
    width: 100%;
    overflow: auto;
  }
  th {
    overflow:hidden;
    color: #fff;
    text-align: center !important;
    padding: 8px;
  }
  tr:nth-child(even){
    background-color:#e8e8e8 !important;
  }
  /*表格中的奇數對 tr*/
  tr:nth-child(odd){
    background-color:#d8d8d8 !important;
  }
  td {
    font-weight: bold;
    // background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: center !important;
    padding: 8px;
  }

  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      color: black;
    }
  }
  .rwd-table {
    margin: auto;
    min-width: 300px;
    max-width: 100%;
    border-collapse: collapse;
  }

.rwd-table tr:first-child {
  border-top: none;
  background: $table-gray !important;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #ebf3f9;
}

.rwd-table tbody th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
.main-title {
  background: rgb(24, 97, 255);
  border: none !important;
}
.score-info {
  font-size: 1.2rem;
  .score-title {
    border-color: #fff !important;
    border-width: 3px !important;
    background-color: #418BCA;
    color: #fff;

  }
  .score {
    font-weight: 600;
  }
  .score-content {
    background-color: #E9F8FF;
    border-color: #fff !important;
    border-width: 3px !important;
  }
}
.radarInfo {
  font-size: 1.25rem;
}
.good {
  color: green;
}
.bad {
  color: red;
}
.normal {
  color:orange;
}
.wrong {
  color: gray;
}

@media screen and (max-width: 601px) {
  .rwd-hide {
    display: none !important;
  }
  .score-title ,.score-content {
    font-size: 1rem !important;
  }
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-td {
    display: block !important;
    background-color: #04a2d6;
  }
  td {
    border: 1px solid #ccc;
  }
}
.lesson-box {
  width: 80%;
}
.group-box {
  width: 20%;
}
.box {
  margin: 5px;
  padding: 10px;
  background-color: #044ed6;
  color: #fff;
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }

  .rwd-table tbody th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    // padding: 1em !important;
  }
}
</style>
